import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Table,
  Card
} from "reactstrap";
import { 
  getUsersAdminRolesList,
  getUsersAdminPermissionsList,
  postCreateSubAdminsCostCenter
} from "../../../helpers/api_rombo_helper";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { map } from "lodash";
import { useNavigate, useParams } from "react-router-dom";

const Step2 = ({ step, setStep, name, phone, email, token, lastName, secondLastName, partnerId, costCenterId, costCenterName, company, isRole, setInfoUser, infoUser, setErrorAlert, setErrorAlertMessage }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [listRoles, setListRoles] = useState()
  const [isLoading, setLoading] = useState(true)
  const [roles, setRoles] = useState([])
  const [selectedRol, setSelectedRol] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [fPermissions, setFPermissions] = useState([]);
  const [listPermissions, setListPermissions] = useState([]);
  const [fListPermissions, setFListPermissions] = useState({});
  const [opts, setOpts] = useState({});
  const [idRoles, setIdRoles] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(7);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const [isSubmitting, setSubmitting] = useState(false);
  const { id: cost_center_id } = useParams();

  useEffect(() => {
    onGetUsersAdminRolesList()
    onGetUsersAdminPermissionsList()
  }, [dispatch]);

  const onGetUsersAdminRolesList = () => {
    let arr = []
    getUsersAdminRolesList(token)
      .then((response) => {
        map(response, (item, key) => (
          arr.push({ value: item.id, label: item.description })
        ))
        setListRoles([...arr]);
  
        const defaultRole = arr.find(role => role.value === "rol_dYveaAsni9UR0Hj1");
        setSelectedRol(defaultRole);
  
        if (defaultRole && !roles.some(r => r.value === defaultRole.value)) {
          setRoles(prevRoles => [...prevRoles, defaultRole]);
          setIdRoles(prevRoles => [...prevRoles, defaultRole.value]);
        }
      })
  }
  
  const onGetUsersAdminPermissionsList = (newOpts = { page: 1, size: 7 }) => {
    getUsersAdminPermissionsList(token, newOpts)
      .then((response) => {
        const filteredPermissions = response.items.filter(permission => 
          permission.rol_name === "Administrador centro de costos" && permission.rol_id === "rol_dYveaAsni9UR0Hj1"
        )
        setListPermissions({ ...response, items: filteredPermissions })
        setFListPermissions(filteredPermissions)
  
        setFPermissions(filteredPermissions.map(permission => ({ ...permission, individual: true })))
        setOpts(newOpts)
      })
      .catch((error) => {
        console.error("Error - getUsersAdminPermissionsList - ", error)
      })
  }

  const onBackNextStep = () => {
    setStep(step - 1);
  }

  const removeRole = (rol) => {
    let arr = roles
    let arrRoles = idRoles
    let onFPermissions = fPermissions
    let onListRoles = listRoles
    let findRole = roles.filter(function(opt) {
      return opt.value === rol.value
    }).shift();
    if(findRole){
      permissions.items.map((per) => {
        if(findRole.value == per.rol_id){
          onFPermissions.splice(onFPermissions.indexOf(per), 1)
          setFPermissions([...onFPermissions])
        }
      })
      onListRoles.push(findRole)
      setListRoles([...onListRoles])
      arrRoles.splice(arrRoles.indexOf(findRole.value), 1)
      setIdRoles(arrRoles)
      arr.splice(arr.indexOf(findRole), 1)
      setRoles([...arr]) 
    }
  }

  const onClickSave = async () => {
    if (isSubmitting) return;

    const selectedUsers = JSON.parse(localStorage.getItem("selectedUsers"));
  
    if (!selectedUsers || selectedUsers.length === 0) {
      setErrorAlertMessage(i18n.t("PleaseSelectAtLeastOneUser"));
      setErrorAlert(true);
      return;
    }
  
    const bodyArray = selectedUsers.map((user) => ({
      user_id: String(user.id),
      user_name: user.name || user.full_name,
      cost_center_id: String(cost_center_id),
      cost_center_name: String(costCenterName),
      partner_id: String(partnerId),
    }));
  
    setSubmitting(true);
  
    try {
      for (const body of bodyArray) {
        await postCreateSubAdminsCostCenter(token, body);
      }
  
      localStorage.setItem("notify", "true");
      localStorage.setItem("headerText", i18n.t("CreatedSubAdmin"));
      localStorage.setItem("bodyText", i18n.t("SuccessCreatedSubAdmin"));
  
      navigate("/cost-centers");
    } catch (error) {
      const errorMessage =
        JSON.stringify(error.response?.data?.detail) || error.message;
  
      setErrorAlertMessage(
        error.code === 500 ? i18n.t("ServerError") : errorMessage
      );
      setErrorAlert(true);
    } finally {
      setSubmitting(false);
    }
  };  

  return (
    <Fragment>
      <CardBody>
        <h6 className="employees-form-title" htmlFor="companyNameInput">
          {i18n.t("RolesByEmployeeModule", { name, lastName })}
        </h6>
        <p className="employees-form-text">
          {i18n.t("DescRolesByEmployeeModule")}
        </p>
        <Col xs={11} xxl={6} xl={6} className="pt-2">
          <Col xs={12} xxl={12} xl={12} className="pt-2 row">
            <Col xs={10} xxl={10} xl={10} className="">
              <Card>
                <Select
                  name="rol"
                  value={selectedRol}
                  id="roles"
                  placeholder={i18n.t("SelectRole")}
                  options={listRoles}
                  className="select2-selection"
                  onChange={(e) => setSelectedRol(e)}
                  isDisabled
                />
              </Card>
            </Col>
          </Col>
          {
            map(roles, (rol, key) => (
              <Col xs={12} xxl={5} xl={4} className="rounded-5 text-white p-1 bg-users mb-1">
                <i onClick={() => removeRole(rol)} className="bx bx-x-circle mx-1"></i>
                {rol.description || rol.label}
              </Col>
            ))
          }
        </Col>
        <div className="request-separator" />
        <h6 className="employees-form-title" htmlFor="companyNameInput">
          {i18n.t("AssignedPermissions")}
        </h6>
        <p className="employees-form-text">
          {i18n.t("AssignedPermissions")} : 4
        </p>
        <Row>
          <Col xxl={12} md={12} xs={12}>
            <div className="table-responsive pt-3">
              <Table className="table table-responsive border">
                <thead>
                  <tr>
                    <th className="bg-light">{i18n.t("Name")}</th>
                    <th className="bg-light">{i18n.t("Category")}</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: i18n.t("ViewCostCenter"), category: i18n.t("CostCenter") },
                    { name: i18n.t("UpdateEmployees"), category: i18n.t("CostCenter") },
                    { name: i18n.t("DeleteEmployees"), category: i18n.t("CostCenter") },
                    { name: i18n.t("AssignServices"), category: i18n.t("CostCenter") },
                  ].map((row, key) => (
                    <tr key={key}>
                      <td>{row.name}</td>
                      <td>{row.category}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            <button onClick={() => onClickSave()} className="btn btn-request">
              {i18n.t("Confirm")}
            </button>
            <button onClick={() => onBackNextStep()} className="btn btn-go-back button-margin-minleft border fs-11">
              {i18n.t("Back")}
            </button>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step2;
